import { render, staticRenderFns } from "./albumDetails.vue?vue&type=template&id=73ddc169&scoped=true&"
import script from "./albumDetails.vue?vue&type=script&lang=js&"
export * from "./albumDetails.vue?vue&type=script&lang=js&"
import style0 from "./albumDetails.vue?vue&type=style&index=0&id=73ddc169&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ddc169",
  null
  
)

export default component.exports